var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMarketEmailIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.724 24.821",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_invitation_1866185_000000",
    transform: "matrix(1, 0, 0, 1, -237.139999, -12.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1857",
    "data-name": "Group 1857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M32.676,16.138l-3.051-2.546V9.979a.571.571,0,0,0-.59-.55H24.594L22.813,7.943a2.833,2.833,0,0,0-3.618.006l-1.781,1.48h-4.5a.571.571,0,0,0-.59.55v3.669l-2.994,2.49a.561.561,0,0,0-.193.437h.011v12.7a2.831,2.831,0,0,0,2.819,2.841H30.033a2.831,2.831,0,0,0,2.819-2.841v-12.7h.011a.515.515,0,0,0-.187-.437Zm-1.265.414-1.786,1.327V15.066ZM19.921,8.816a1.7,1.7,0,0,1,2.172.006l.72.607H19.19Zm8.569,1.747v8.161l-6.46,4.809a1.727,1.727,0,0,1-2.047,0l-6.522-4.855V10.563ZM12.327,15.117v2.717L10.6,16.546ZM30.039,30.98H11.97a1.7,1.7,0,0,1-1.684-1.707V17.7l9.029,6.743a2.842,2.842,0,0,0,3.38,0L31.723,17.7V29.267a1.7,1.7,0,0,1-1.684,1.713Z",
    transform: "translate(228 5)",
    fill: "#5c3bd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M 245.488 19.234 L 248.551 19.234 C 248.987 19.234 249.26 18.762 249.042 18.384 C 248.941 18.208 248.754 18.1 248.551 18.1 L 245.488 18.1 C 245.052 18.1 244.779 18.573 244.997 18.951 C 245.098 19.126 245.285 19.234 245.488 19.234 Z",
    fill: "#5c3bd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M 245.488 22.07 L 252.52 22.07 C 252.956 22.07 253.229 21.597 253.011 21.219 C 252.91 21.044 252.723 20.936 252.52 20.936 L 245.488 20.936 C 245.052 20.936 244.779 21.408 244.997 21.786 C 245.098 21.962 245.285 22.07 245.488 22.07 Z",
    fill: "#5c3bd8"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketEmailIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/market-email-icon.bb8b07bf.svg";
export { ForwardRef as ReactComponent };